module.exports = __webpack_public_path__ + "img/4Z.5ee6584e.png";